import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export const SOLD_COUNT_BADGE_EXPERIMENT = 'experiment.soldCountBadge'

/**
 * Knows whether the sold count badge can render on product cards.
 *
 * Rollout gate only: the country flag and the CloudBees assignment; whether a
 * given card shows the badge is decided by the card. Any state other than the
 * `withBadge` arm keeps the badge off (safe default).
 */
export function useSoldCountBadge() {
  const { FF_ENABLE_SOLD_COUNT_BADGE_COUNTRIES = '' } = useRuntimeConfig()
    .public as { FF_ENABLE_SOLD_COUNT_BADGE_COUNTRIES?: string }
  const { countryCode } = useMarketplace().market
  const experiments = useExperiments()

  const isSoldCountBadgeEnabled = computed(
    () =>
      FF_ENABLE_SOLD_COUNT_BADGE_COUNTRIES.includes(countryCode) &&
      experiments[SOLD_COUNT_BADGE_EXPERIMENT] === 'withBadge',
  )

  return { isSoldCountBadgeEnabled }
}
